import { HTMLAttributes } from 'react';
import FillInBasicInformationGenerateQuote from '@/website/components/switchWithJove/fillInBasicInformationGenerateQuote/index';
import AlreadyInsuredElsewhereView from '@/website/components/switchWithJove/home/alreadyInsuredElsewhere';
import BriefIntroduction from '@/website/components/switchWithJove/quickCostCalculator/briefIntroduction';
import { Box, Container } from '@mui/material';
import clsx from 'clsx';

type QuickCostCalculatorProps = HTMLAttributes<HTMLDivElement> & {
  providerCode?: string;
};

const QuickCostCalculator = (props: QuickCostCalculatorProps) => {
  const { className, providerCode } = props;

  return (
    <Box component={Container} className={clsx('flex w-full flex-col items-center px-4 md:px-6', className)}>
      <Box className="flex w-full max-w-[1280px] flex-col gap-8 py-6 lg:flex-row lg:gap-10">
        <Box className="flex w-full flex-1 flex-col justify-center">
          <AlreadyInsuredElsewhereView topIconClassName="bg-white" featureIconClassName="bg-white" />
        </Box>
        <Box className="w-full flex-1">
          <FillInBasicInformationGenerateQuote policyExpireDateIsRequired={false} providerCode={providerCode} />
        </Box>
      </Box>
    </Box>
  );
};

export default QuickCostCalculator;
